<div class="row mx-0 w-100 appSettingsDraw">
    <div class="row mx-0 sg-box-style align-items-center">
        <mat-icon class="sg-upload-icon d-flex align-items-center"> settings </mat-icon>
        &nbsp; Application Settings
    </div>
    <hr>

    <form [formGroup]="appSettingsFormGroup" novalidate autocomplete="off" class="appSettings">
        <div class="row mx-0">
            <div class="col-10 p-0">
                <label class="sg-supllier-number1">Allowed File Size (MB) <span
                        class="sg-form-field-required-marker ng-star-inserted">*</span> </label>
                <mat-form-field appearance="outline" class="w-100">
                    <mat-select formControlName="allowedFileSize">
                        <mat-option *ngFor="let option of fileSizeOption" [value]="option">
                            {{option}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </form>
    <div class="row  mx-0 border-top w-100 sg-bottom-btn appBtns">
        <div class="col-12 row mx-0 justify-content-end">
            <button mat-raised-button class="mat-primary mat-raised-button mt-2 mr-3"
            [disabled]="!appSettingsFormGroup.valid || !appSettingsFormGroup.dirty"
            (click)="onSaveClick()">
                Save
            </button>
            <button mat-stroked-button="" type="button" 
            class="sg-primary-stroked mat-stroked-button mt-2 mr-3"
            (click)="onCancelClick()">
                Cancel
            </button>
        </div>
    </div>
</div>
<div class="sg-spinner" style="z-index: 99999;" *ngIf="isLoadingData">
    <mat-spinner></mat-spinner>
</div>